module.exports = __webpack_public_path__ + "img/daishouyarenyuan.b7042343.png";